import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";

import BlogForm from "../pages/BlogForm";
import SEO from "../components/SEO";
const Item = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  borderRadius: "10px",
  border: " 1.5px solid #C4D2EE",
  height: "430px",
  width: "270px",
  backgroundColor: "#fff",
  padding: theme.spacing(1),
  //   textAlign: 'left',
  //   color: theme.palette.text.secondary,
}));

export default function RowAndColumnSpacing() {
  return (
    <>
      <SEO
        title="Refund and Cancellation Policy | Leeway softech Pvt Ltd"
        description="Click here to read refund and cancellation policy as well as important details about our IT Services. In case of any queries, reach out to us."
      />
      <Grid container spacing={1} className="digital_page main_content">
        <Grid item xs={12} sm={12} lg={12} className="p-[5%]">
          <div style={{}}>
            <h1 className="text-white text-center text-[32px] d-flex m-auto">
              Privacy Policy
            </h1>
            {/* <p style={{ color: 'white', textAlign: 'center' }}>Online digital marketing is the foundation of a successful online presence and can be used to drive customer participation, increase brand value, and build trust. It is important to create content that is relevant, engaging, and consistent. With a motive to provide the simplest solution for complex problems, Leeway Softech started way back with a mission to innovate, facilitate, and automate.</p> */}
          </div>
        </Grid>
      </Grid>

      <Box className="w-[100%]">
        <Grid
          container
          spacing={2}
          columns={16}
          className="blog_card flex justify-center p-2.5"
        >
          <Grid item xs={6} className=" flex justify-center">
            <div className="text-center mr-[15%] ml-[15%]">
              {" "}
              {/* Increased padding and added margin */}
              <h2 className="text-left mb-5 font-[400]">Opt-in Consent</h2>
              <p className="text[#161011] text-sm text-left opacity-[80%] mb-5">
                By filling out our Contact Us form, you are giving your consent
                to receive transactional and promotional conversations. Stay
                informed about important updates, order confirmations, and
                personalized offers tailored to your interests. Be the first to
                know about new products, exclusive deals, exciting promotions
                and services related updates.We promise to respect your privacy
                and provide valuable content.
              </p>
              <h2 className="text-left mb-5 font-[400] text-[#161011]">
                Opting Out of Email or Other Communication Channel
              </h2>
              <p className="text-left mb-5 font-[400] text-[#161011] text-[15px] opacity-85">
                We authenticate to get your consent before gathering, processing
                and storing your individual data. You can take back your consent
                anytime. Data subjects have the power to terminate transfers
                from us.
              </p>
              <h2 className="text-left mb-5 font-[400] text-[#161011]">
                Amendment in this Privacy Statement
              </h2>
              <p className="text-left mb-5 font-[400] text-[#161011] text-[15px] opacity-85">
                {" "}
                Leeway Softech has the comprehensive authority to alter, amend,
                or adjust this Privacy Policy from time to time. We request you
                to view this page occasionally to know the modifications and new
                updates.
              </p>
              <h2 className="text-left mb-5 font-[400] text-[#161011]">
                Complaints
              </h2>
              <p className="text-left mb-5 font-[400] text-[#161011] text-[15px] opacity-85">
                {" "}
                If you know someone who needs our support, please contact us.
                You may simply send us an Email at
                customercare@leewaysoftech.com
              </p>
              <h2 className="text-left mb-5 font-[400] text-[#161011]">
                Contact Information
              </h2>
              <p className="text-left mb-5 font-[400] text-[#161011] text-[15px] opacity-85">
                {" "}
                For any queries about the privacy policy or legal guidelines
                please contact us at 8000305305
              </p>
            </div>
            <div></div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
